<template>
  <div style="display:flex; height:100%;">
    <!-- 左侧面板 -->
    <div class="sidebar">
      <!-- 标签切换 -->
      <div class="tab-bar">
        <div :class="['tab-item', tab=='class'?'active':'']" @click="switchTab('class')">
          <span class="tab-icon">📚</span> 课程
        </div>
        <div :class="['tab-item', tab=='exercise'?'active':'']" @click="switchTab('exercise')">
          <span class="tab-icon">📝</span> 作业
        </div>
      </div>

      <!-- 课程列表 -->
      <div class="sidebar-scroll" v-if="tab == 'class'">
        <div v-for="(s,i) in list" :key="'list-'+i" class="lesson-group">
          <div class="lesson-header" @click="showList(i)">
            <div class="lesson-num">{{ i + 1 }}</div>
            <div class="lesson-name">{{ s.name }}</div>
            <div class="lesson-arrow" :class="{ open: s.open }">▾</div>
          </div>
          <div :class="['topic-list', s.open ? 'expanded':'']" :style="{ maxHeight: s.open ? s.topic.length * 44 + 'px' : '0' }">
            <div v-for="(t,j) in s.topic" :key="'topic-'+j" :class="['topic-item', currentTopicPath == t.path ? 'active' : '']" @click="loadProject(t)">
              <div class="topic-dot"></div>
              <span>{{ t.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 练习列表 -->
      <div class="sidebar-scroll" v-if="tab == 'exercise'">
        <div v-for="(s,i) in exerciseList" :key="'ex-'+i" class="lesson-group">
          <div class="lesson-header" @click="showExerciseList(i)">
            <div class="lesson-num">{{ i + 1 }}</div>
            <div class="lesson-name">{{ s.name }}</div>
            <div class="lesson-arrow" :class="{ open: s.open }">▾</div>
          </div>
          <div :class="['topic-list', s.open ? 'expanded':'']" :style="{ maxHeight: s.open ? s.topic.length * 44 + 'px' : '0' }">
            <div v-for="(t,j) in s.topic" :key="'extopic-'+j" :class="['topic-item', currentTopicPath == t.path ? 'active' : '']" @click="loadProject(t)">
              <div class="topic-dot"></div>
              <span>{{ t.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧主区域 -->
    <div class="main-area">
      <!-- 编辑器 -->
      <div class="editor-container">
        <editor v-model="code" :lang="language" :height="editorHeight" theme="tomorrow_night" ref="aceEditor"/>
      </div>

      <!-- 运行输出面板 -->
      <div class="output-panel" v-if="result || running">
        <div class="output-header">
          <span class="output-title">运行输出</span>
          <div class="output-header-right">
            <span class="output-running" v-if="running">
              <span class="spinner-sm"></span> 运行中...
            </span>
            <button class="output-close" @click="clearResult">✕</button>
          </div>
        </div>
        <div class="output-body" v-if="result" v-html="result"></div>
        <div class="output-body output-loading" v-else>
          <div class="spinner"></div>
          <p>程序运行中...</p>
        </div>
      </div>

      <!-- 底部操作栏 -->
      <div class="action-bar">
        <div class="action-left">
          <input
            class="stdin-input"
            type="text"
            v-model="stdinText"
            placeholder="标准输入（可选）"
          />
          <button class="btn-run" @click="copyToClipboard">
            <span class="btn-run-icon">▶</span> 运行程序
          </button>
        </div>
        <div class="action-right">
          <span class="ws-status" :class="{ connected }">
            <span class="ws-dot"></span>
            {{ connected ? '已连接' : '未连接' }}
          </span>
          <button v-if="tab == 'exercise'" class="btn-clear" @click="clearCache">清除缓存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import editor from "vue2-ace-editor";
import util from '@/utils/util';

// ACE 编辑器模式与主题（必须导入否则编辑器无法正常渲染）
import 'brace/mode/c_cpp';
import 'brace/mode/java';
import 'brace/mode/python';
import 'brace/theme/tomorrow_night';

export default {
  name: 'HelloWorld',
  data() {
    return {
      msg: '',
      show:false,
      code:'//请从左侧选择一个项目',
      result:null,
      running: false,
      list:[],
      exerciseList:[],
      project:{},
      language:'c_cpp',
      configLanguage:'cpp',  // 原始语言代码，用于 API 请求
      tab:'class',
      editorHeight:null,
      socket:null,
      saveTimer:null,
      currentTopicPath:null,
      stdinText:'',   // 标准输入内容
      // 多屏同步相关（与 bak 版本一致，原样搬入，不做改动）
      connected:false,// WebSocket 是否已连接
      loopCheck:true, // 心跳检测标志（初始 true，第一次心跳发送检查）
    };
  },
  components:{
    editor
  },
  watch: {
    code(newVal) {
      // 自动保存到本地（多屏同步发送逻辑与 bak 版本一致：走 ACE 编辑器 input 事件，watch 里只做本地保存）
      if (this.currentTopicPath) {
        if (this.saveTimer) clearTimeout(this.saveTimer);
        this.saveTimer = setTimeout(() => {
          const classId = this.$route.params.classId;
          localStorage.setItem('class_code_' + classId + '_' + this.currentTopicPath, newVal);
        }, 500);
      }
    },
  },
  mounted() {
    const classId = this.$route.params.classId;
    console.log('Class ID:', classId);

    this.loadList();
      setTimeout(() => {
        const aceInput = document.getElementsByClassName("ace_text-input")[0];
        if (aceInput) {
          aceInput.addEventListener('paste', this.handlePaste);
        }
      }, 500);
    this.connectLoop();
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.close();
    }
  },
  methods: {
    handlePaste(){
      if(this.socket != null){
        var mobile = this.$route.params.classId;
        var target = "patrick";

        if(util.getSearchString("mobile") != null){
          mobile = util.getSearchString("mobile");
        }

        if(util.getSearchString("target")!= null){
          target = util.getSearchString("target");
        }
        if(mobile == null || mobile == ""){
          mobile = 's1';
          target = 't1';
          
        }

        if(mobile == null || mobile == ""){
            return;
        }
        var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
          try{
            this.socket.send(sendStr);
          }
          catch( err){

          }
      }
    },
    loadList(){
      this.$http.get('/data/classes/'+this.$route.params.classId+'.json?dt='+new Date().getTime()).then(response => {
        this.list=response.data;
      });
      // 练习列表
      this.$http.get('/data/classes/'+this.$route.params.classId+'-exercise.json?dt='+new Date().getTime()).then(response => {
        this.exerciseList=response.data;
      });

      // 获取语言配置
      this.$http.get('/config/'+this.$route.params.classId+'.json').then(response => {
        if(response.data.language){
          // 保存原始语言代码，用于 API 请求
          this.configLanguage = response.data.language;
          // 配置中的语言代码映射到 ACE 编辑器的 mode 名称
          const langMap = { 'py': 'python', 'cpp': 'c_cpp', 'java': 'java' };
          this.language = langMap[response.data.language] || response.data.language;
          console.log("Language："+this.language);
        }
      });
    },

    showList(index){
      this.list[index].open =!this.list[index].open;
      this.$forceUpdate();
    },
    showExerciseList(index){
      this.exerciseList[index].open =!this.exerciseList[index].open;
      this.$forceUpdate();
    },
    connectLoop(){
      var mobile = this.$route.params.classId;
      var target = "patrick";

      if(util.getSearchString("mobile") != null){
        mobile = util.getSearchString("mobile");
      }

      if(util.getSearchString("target")!= null){
        target = util.getSearchString("target");
      }

      if(mobile != null && mobile != ""){
        if(!this.connected){
          this.connectServer();
        }

        var interval = setInterval( ()=>{
          if(!this.connected){
            this.connectServer();
          }
          else{
            clearInterval(interval);
          }
        },5000);
        
      }
      else{
        mobile = 's1';
        target = 't1';
        if(!this.connected){
          this.connectServer();
        }

        var interval = setInterval( ()=>{
          if(!this.connected){
            this.connectServer();
          }
          else{
            clearInterval(interval);
          }
        },5000);
      }
    },
    connectServer(){
      
      var mobile = this.$route.params.classId;
      var target = "patrick";

      if(util.getSearchString("mobile") != null){
        mobile = util.getSearchString("mobile");
      }

      if(util.getSearchString("target")!= null){
        target = util.getSearchString("target");
      }

      if(mobile == null || mobile == ""){
        mobile = 's1';
        target = 't1';
        
      }
      
      const socket = new WebSocket('wss://wss.dctechonline.cn:8024');
      this.socket = socket;

      // When the connection is established
      socket.addEventListener('open', event1 => {
        console.log('WebSocket connection established.');
        
        socket.send(JSON.stringify(
          {
              type:"user",
              mobile:mobile,
              target:target,
              classType:'cpp',
          }));


          var interval2 = setInterval( ()=>{
            if(this.loopCheck == false){
              
              clearInterval(interval2);
              this.connected = false;
              this.connectLoop();
              return;
            }
            else{
              socket.send(JSON.stringify(
              {
                  type:"loopcheck",
                  mobile:mobile
              }))
              this.loopCheck = false;
              console.log('check successful');
            }
          },20000);


          this.connected = true;

          socket.addEventListener('message', event => {
        // 创建一个 FileReader 对象 
          const reader = new FileReader();

          // 当 FileReader 加载完成后，将 Blob 转换为字符串
          reader.addEventListener('loadend', () => {
            const text = reader.result;
            const data = JSON.parse(text);
            const { type, value,from } = data;
            console.log(data);
            if (type === 'classcode' && from == target) {
              // Update the editor with the new text
              this.code = value;
            }
            else if(type ==="loopcheck"){
              this.loopCheck = true;
            }
          });

          // 读取 Blob 内容
          reader.readAsText(event.data);
        });
  
        // // When the editor's content changes

        if(this.$refs.aceEditor){
          this.$refs.aceEditor.$vnode.elm.children[0].addEventListener('input', event => {
          // var target = target;
            var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
            try{
              socket.send(sendStr);
            }
            catch( err){
              // this.connected = false;
              // this.connectLoop();
            }
          
          });
        }
      });
    },
    loadProject(p){
      const classId = this.$route.params.classId;

      if (this.currentTopicPath) {
        localStorage.setItem('class_code_' + classId + '_' + this.currentTopicPath, this.code);
      }

      this.currentTopicPath = p.path;

      localStorage.setItem('class_last_topic_' + classId, p.path);

      const savedCode = localStorage.getItem('class_code_' + classId + '_' + p.path);
      if (savedCode !== null) {
        this.code = savedCode;
        const savedResult = localStorage.getItem('class_result_' + classId + '_' + p.path);
        this.result = savedResult !== null ? savedResult : null;
        return;
      }

      this.result = null;
      this.project = p;
      var r = new Date().getTime();
      this.$http.get(p.path+"?random="+r, { responseType: 'arraybuffer' }).then(response => {
        const decoder = new TextDecoder('utf-8');
        const content = decoder.decode(response.data);
        this.code = content;
      }).catch(error => {

      });
    },
    copyToClipboard(){
      var code = this.code;

      // API 语言参数映射
      const apiLangMap = { 'py': '7', 'python': '7', 'cpp': 'cpp', 'java': 'java' };
      const apiLanguage = apiLangMap[this.configLanguage] || this.configLanguage;

      // 根据语言确定文件扩展名（不带点）
      const extMap = { 'cpp': 'cpp', 'c': 'c', 'py': 'py', 'python': 'py', 'java': 'java' };
      const fileext = extMap[this.configLanguage] || this.configLanguage;

      // Python 代码自动添加 UTF-8 编码声明，避免后端执行时报 Non-ASCII 错误
      if (['py', 'python'].includes(this.configLanguage)) {
        const header = '# -*- coding: utf-8 -*-\n';
        if (!code.startsWith(header)) {
          code = header + code;
        }
      }

      // 构建 JSON 参数，code/stdin 需要 encodeURIComponent
      // 因为后端会把参数拼接到 form-urlencoded 字符串转发给 runoob，
      // 提前编码可避免 +、&、^ 等特殊字符在 runoob 端被误解析
      let postInfo = {
        "code": encodeURIComponent(code),
        "language": apiLanguage,
        "stdin": encodeURIComponent(this.stdinText),
        "fileext": fileext,
      };
      console.log(postInfo);

      if(this.language == "processing"){
        // Processing 项目则使用 processing.js 在前端运行
        this.running = true;
        var project = this.project;
        var path = project.path.substring(0, project.path.lastIndexOf('/'));
        console.log(path);

        var self = this;
        var canvas = document.createElement("canvas");
        canvas.id ="processingCanvas";
        function setResult(content){
          self.result = content;
          self.running = false;
        }
        var processingInstance = new Processing(canvas, code);
        setTimeout(function(){
          var output = document.getElementById("processingCanvas");
          var result = document.getElementById("result");
          if(output){
            // result.appendChild(canvas);
            setResult(output);
          }else{
            setResult('程序运行完毕，输出见上方Canvas');
          }
        }, 500);

      }else{
        // 其他语言通过 API 运行
        this.running = true;
        this.result = null;
        this.$http.post("https://aiapi.dctechonline.cn/api/runcode", postInfo).then(response => {
            console.log(response.data);
            this.running = false;
            const output = response.data.output != '' ? response.data.output.replace(/\n/g, '<br>') : response.data.errors.replace(/\n/g, '<br>');
            this.result = output;
            const classId = this.$route.params.classId;
            if (this.currentTopicPath) {
              localStorage.setItem('class_result_' + classId + '_' + this.currentTopicPath, output);
            }
          });
        }
    },
    clearResult() {
      this.result = null;
      const classId = this.$route.params.classId;
      if (this.currentTopicPath) {
        localStorage.removeItem('class_result_' + classId + '_' + this.currentTopicPath);
      }
    },
    switchTab(tab){
      this.tab = tab;
    },
    clearCache() {
      const classId = this.$route.params.classId;
      const prefix = 'class_code_' + classId + '_';
      const resultPrefix = 'class_result_' + classId + '_';
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (key && (key.startsWith(prefix) || key.startsWith(resultPrefix))) {
          localStorage.removeItem(key);
        }
      }
      this.code = '//请从左侧选择一个项目';
      this.result = null;
      this.currentTopicPath = null;
    },
  },
  computed: {
  },
  created() {
    this.editorHeight = window.innerHeight-120+'px';
  },
};
</script>

<style lang="scss" scoped>
// 侧边栏
.sidebar {
  width: 300px;
  min-width: 300px;
  background: var(--bg-surface);
  border-right: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

// Tab 切换栏
.tab-bar {
  display: flex;
  border-bottom: 2px solid var(--border-color);
  flex-shrink: 0;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 14px 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-muted);
  cursor: pointer;
  transition: all var(--transition-fast);
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  user-select: none;

  .tab-icon {
    margin-right: 4px;
  }

  &:hover {
    color: var(--text-secondary);
    background: var(--bg-surface-hover);
  }

  &.active {
    color: var(--color-primary);
    border-bottom-color: var(--color-primary);
    background: var(--color-primary-light);
  }
}

// 滚动区域
.sidebar-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}

// 课程组
.lesson-group {
  margin: 2px 8px;
}

.lesson-header {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
  user-select: none;

  &:hover {
    background: var(--bg-surface-hover);
  }
}

.lesson-num {
  width: 26px;
  height: 26px;
  border-radius: var(--radius-sm);
  background: var(--color-primary-light);
  color: var(--color-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  margin-right: 10px;
  flex-shrink: 0;
}

.lesson-name {
  flex: 1;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lesson-arrow {
  font-size: 14px;
  color: var(--text-muted);
  transition: transform var(--transition-normal);
  margin-left: 4px;

  &.open {
    transform: rotate(180deg);
  }
}

// 小节列表
.topic-list {
  overflow: hidden;
  transition: max-height 0.3s ease;
  max-height: 0;
}

.topic-item {
  display: flex;
  align-items: center;
  padding: 8px 12px 8px 48px;
  font-size: 13px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all var(--transition-fast);
  border-radius: var(--radius-sm);
  margin: 1px 4px;

  &:hover {
    background: var(--color-primary-light);
    color: var(--color-primary);
  }

  &.active {
    background: var(--color-primary-light);
    color: var(--color-primary);
    font-weight: 600;
  }
}

.topic-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--border-color);
  margin-right: 10px;
  flex-shrink: 0;
  transition: all var(--transition-fast);
}

.topic-item:hover .topic-dot,
.topic-item.active .topic-dot {
  background: var(--color-primary);
}

// ========================
// 右侧主区域
// ========================
.main-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #1e1e1e;
  position: relative;
  overflow: hidden;
}

.editor-container {
  flex: 1;
  overflow: hidden;

  :deep(.ace_editor) {
    font-size: 14px;
    line-height: 1.5;
  }
}

// 底部操作栏
.action-bar {
  height: 64px;
  min-height: 64px;
  background: #252526;
  border-top: 1px solid #3c3c3c;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.action-left,
.action-right {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  top: -4px;
}

.stdin-input {
  width: 160px;
  height: 32px;
  padding: 4px 10px;
  border: 1px solid #4a4a4a;
  border-radius: 4px;
  background: #1a1a1a;
  color: #d4d4d4;
  font-size: 13px;
  font-family: 'Fira Code', 'Consolas', monospace;
  outline: none;
  transition: border-color var(--transition-fast);

  &::placeholder {
    color: #6b6b6b;
  }

  &:focus {
    border-color: var(--color-primary);
  }
}

.btn-run {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 18px;
  border: none;
  border-radius: var(--radius-sm);
  background: var(--color-success);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);

  &:hover {
    background: #059669;
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}

.btn-run-icon {
  font-size: 12px;
}

.ws-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #6b7280;
}

.btn-clear {
  padding: 6px 16px;
  border: 1px solid #4a4a4a;
  border-radius: var(--radius-sm);
  background: #3a3a3a;
  color: #d4d4d4;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);

  &:hover {
    background: #666;
    border-color: #666;
  }

  &:active {
    background: #555;
  }
}

.ws-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #6b7280;
  transition: background var(--transition-normal);

  .connected & {
    background: var(--color-success);
    box-shadow: 0 0 6px rgba(16, 185, 129, 0.5);
  }
}

// 输出面板
.output-panel {
  flex-shrink: 0;
  max-height: 220px;
  background: #1a1a2e;
  border-top: 1px solid #3c3c3c;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.output-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: #16213e;
  border-bottom: 1px solid #3c3c3c;
  flex-shrink: 0;
}

.output-title {
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.output-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.output-running {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #fbbf24;
}

.spinner-sm {
  width: 12px;
  height: 12px;
  border: 2px solid #334155;
  border-top-color: #fbbf24;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.output-close {
  width: 22px;
  height: 22px;
  border: none;
  background: transparent;
  font-size: 14px;
  color: #64748b;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);

  &:hover {
    background: rgba(239, 68, 68, 0.2);
    color: #f87171;
  }
}

.output-body {
  padding: 12px 16px;
  font-size: 13px;
  color: #e2e8f0;
  font-family: 'Fira Code', 'Consolas', monospace;
  line-height: 1.5;
  overflow-y: auto;
  flex: 1;
  white-space: pre-wrap;
  word-break: break-all;
}

.output-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 24px 0;

  p {
    margin: 0;
    color: #64748b;
    font-family: inherit;
  }
}

.spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #334155;
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
